<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0">{{$t('liis.page_title')}}</h1>
    </template>

    <template v-slot:leftPanel>
      <TocWidget :toc="contentswdgt"></TocWidget>
    </template>

    <template v-slot:mainPanel>

      <v-divider></v-divider>
      <h2 id="liifalm" class="text-h2 liiblack--text mt-3 mb-4">{{$t('liis.t_falm')}}</h2>

      <div class="pt-3 pb-3">
        <i18n path="liis.liis[0]" tag="p">
          <a href="http://fatlm.org/">{{$t('liis.fatlm')}}</a>
        </i18n>
      </div>

      <v-row class="mb-10">
        <v-col v-for="(col, colnum) in clicsCol" cols="12" lg="6" class="pr-md-4 py-0" :key="colnum">
          <table class="col-12 mx-auto pl-md-7">
            <tbody>
              <tr v-for="(lii, idx) in col" :key="'lii_left' + idx">
                <td>
                  <a v-if="lii.website" :href="lii.website" target="_blank">
                    <img :src="lii.imgsrc" :alt="lii.title" :title="lii.title" />
                  </a>
                  <img v-else :src="lii.imgsrc" :alt="lii.title" :title="lii.title" />
                </td> 
                <td>
                  <strong>{{lii.title}}</strong><br>
                  <a v-if="lii.website" :href="lii.website" target="_blank">{{lii.name}}</a>
                  <div v-else>{{lii.name}}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>

      <br>
      <v-divider></v-divider>
      <h2 id="liiclic" class="text-h2 liiblack--text mt-3 mb-4">{{$t('liis.t_clic')}}</h2>
      <div class="pt-3 pb-3">
        <p>{{$t('liis.liis[1]')}}</p>
      </div>

      <table class="col-12 mx-auto pl-md-7 mb-10" id="clics">
        <tbody>
          <tr v-for="(clic, idx) in clics" :key="'clic' + idx">
            <td><a :href="clic[$i18n.locale].link" target="_blank"></a><img :src="clic.imgsrc" :alt="clic.name" :title="clic.name" /></td>
            <td>
              <strong>{{clic.name}}</strong><br>
              <a :href="clic[$i18n.locale].link">{{clic[$i18n.locale].text}}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import TocWidget from '../components/TocWidget'
  import liis from '@/data/liis.json'
  import clics from '@/data/clics.json'
  export default {
    name: 'Liis',
    components:{
      ThreeColumn,
      TocWidget
    },
    data(){
      return {
        liis: liis,
        clics: clics
      }
    },
    /*watch: {
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('liis.page_title')} | HKLII`
      }
    },*/
    computed:{
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('liis.page_title'), disabled: true}
        ]
      },
      contentswdgt(){
        return [
          {'title':this.$i18n.t('liis.t_falm'), id:'liifalm'},
          {'title':this.$i18n.t('liis.t_clic'), id:'liiclic'},
        ]
      },
      clicsCol(){
        // liis shown in 2 columns on large screens, 1 column on small screens
        if(this.$vuetify.breakpoint.mdAndDown){
          return [this.liis]
        } else {
          const half = Math.ceil(liis.length / 2)
          return [liis.slice(0, half), liis.slice(half)]
        }
      }
    },
    /*mounted(){
      window.document.title = `${this.$i18n.t('liis.page_title')} | HKLII`
    }*/
    metaInfo(){
      return{
        title: this.$i18n.t('liis.page_title'),
      }
    },
  }
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  table {
    border-collapse: collapse;
    width: 100%;
  }

  td{
    //border: 1px solid #ddd;
    border-left: none;
    border-right: none;
    padding: 8px;      
  }

  tr:nth-child(odd){
    background-color: var(--v-footergrey-lighten2);
  }

  tr:hover {
    background-color: var(--v-footergrey-lighten1); 
  }

  a {
    @include link-no-underline;
  }
</style>